import {Component, inject, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";

import {appRoutes} from "@numizmat/constants";
import {environment} from "@numizmat/environments";
import {MetaTagService} from "@numizmat/services/common";
import {PageHeaderComponent} from "@numizmat/components";

@Component({
  selector: 'nz-password-recovery-success',
  standalone: true,
  imports: [
    RouterLink,
    PageHeaderComponent
  ],
  templateUrl: './password-recovery-success.component.html',
  styleUrl: './password-recovery-success.component.scss'
})
export class PasswordRecoverySuccessComponent implements OnInit {
  private metaTagService: MetaTagService = inject(MetaTagService);

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.setMetaTags();
  }

  private setMetaTags(): void {
    this.metaTagService.setCanonicalUrl(`${environment.applicationDomain}/${appRoutes.account}/${appRoutes.passwordRecoverySuccess}`);
    this.metaTagService.setTitle('Регистрация | Collectoria');
    this.metaTagService.setDescription('Регистрация | Collectoria');
  }
}
